//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { makeStyles } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
// import { MESSAGE_DIALOG_TITLE_THANK_YOU_FOR_PURCHASE } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdMessageDialog from '../../common/elemental/AfitdMessageDialog';
import AfitdButton from '../../common/elemental/AfitdButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
import _noop from 'lodash/noop';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        subtitle: { fontWeight: 'bold' },

        // lineSeprator: { borderTop: '2px solid rgb(240,242,246)', margin: '20px 0' },

        hidden: { display: 'none' },
        checkCirlce: {
            color: theme.palette.secondary.main,
            fontSize: '100px',
        },
        container: {
            textAlign: 'center',
        },
        okButton: {
            width: '220px',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props, handleCloseDialog } = params;
    const { open } = props;

    const defns = {
        thankYouMessageDialog: {
            // title: MESSAGE_DIALOG_TITLE_THANK_YOU_FOR_PURCHASE,
            open,
            onClose: handleCloseDialog,
            okButtonColor: 'secondary',
            maxWidth: 'sm',
            noActions: true,
        },
        okButton: {
            color: 'secondary',
            onClick: handleCloseDialog,
        },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ThankYouForPurchaseDialog = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    // const appContext = useContext(AppContext);
    // const { currentEmployer, employerId } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { onClose = _noop } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleCloseDialog = () => {
        onClose && onClose();
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        handleCloseDialog,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <AfitdMessageDialog {...defns.thankYouMessageDialog}>
            <div {...defns.container}>
                <CheckCircleIcon {...defns.checkCirlce} />
                <AfitdTypography varaint="h6">Success!</AfitdTypography>
                <br />
                <AfitdTypography {...defns.message}>Your Order was processed successfully. We sincererly thank you for your business.</AfitdTypography>
                <br />
                <br />
                <br />
                <AfitdButton {...defns.okButton}>Okay</AfitdButton>
            </div>
        </AfitdMessageDialog>
    );
};

export default ThankYouForPurchaseDialog;
